import { render, staticRenderFns } from "./messagesWrapper.vue?vue&type=template&id=241bd99b&scoped=true&lang=html&"
import script from "./messagesWrapper.vue?vue&type=script&lang=js&"
export * from "./messagesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./messagesWrapper.vue?vue&type=style&index=0&id=241bd99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241bd99b",
  null
  
)

export default component.exports